import { AuthAttribute, authAttributeSerializer } from "@megaron/access-control";
import { HttpUri } from "@megaron/http-uri";
import { MegaraxUri } from "@megaron/megarax-uri";
import { Serializers } from "@megaron/serializers";

import { ResourceId, resourceIdSerializer } from "./ResourceId";

export type BaseDoc<T extends string = string> = {
  docType: T;
  docId: ResourceId<T>;
  uri?: MegaraxUri | HttpUri;
  authorizedAttributes: AuthAttribute[];
  name: string;
  isArchived: boolean;
  boostedFor: AuthAttribute[];
};

export const baseDocSerializer = <T extends string>(docType: T) =>
  Serializers.object({
    docType: Serializers.stringOneOf(docType),
    docId: resourceIdSerializer(docType),
    uri: Serializers.first(MegaraxUri.serializer, HttpUri.serializer).optional(),
    authorizedAttributes: authAttributeSerializer.array(),
    boostedFor: authAttributeSerializer.array(),
    isArchived: Serializers.boolean,
    name: Serializers.string,
  });
